@if (params.icon === 'solid-calendar-today') {
  <span class="flex-0 overflow-hidden" [class.placeholder]="!params.value">
    {{ params.value ? (params.value | DateTime: 'DATE_SHORT') : ('ANGULAR_COMPONENT_LIBRARY.OBJECT_SELECTION.SELECT_OBJECT' | bmsTranslate: {object: params.objectKey}) }}
  </span>
} @else {
  <span class="flex-0 overflow-hidden" [class.placeholder]="!params.value">{{ !params.value ? params.placeholder : params.value }}</span>
}
@if (params.column.isCellEditable(params.node)) {
  <mat-icon class="flex-no-shrink" [svgIcon]="params.icon"></mat-icon>
}
